import React from 'react';

import classNames from 'classnames';
import { range } from 'lodash';
import Skeleton from 'react-loading-skeleton';

export default function TableRowSkeleton({ rows = 1, columns = 5, fixed = false }) {
    return range(rows).map((row, index) => (
        <tr key={index}>
            {range(columns).map((col, colIndex) => (
                <td key={colIndex} className={classNames({ 'tw-sticky tw-left-0 tw-h-fit': fixed })}>
                    <Skeleton width="100%" height={20} />
                </td>
            ))}
        </tr>
    ));
}
